module.exports = __webpack_public_path__ + "static/media/customer-prospecting.d708f2b2.svg";